var STORAGE_KEY_PREFIX = 'chequeBlockUntil';
export var getChequeBlockKey = function (gamblerId) { return "".concat(STORAGE_KEY_PREFIX, "_").concat(gamblerId); };
export var saveChequeBlock = function (gamblerId, timeoutMs) {
    if (!gamblerId || !timeoutMs || timeoutMs <= 0) {
        return null;
    }
    var blockUntil = Date.now() + timeoutMs;
    localStorage.setItem(getChequeBlockKey(gamblerId), String(blockUntil));
    return blockUntil;
};
export var getChequeBlockUntil = function (gamblerId) {
    if (!gamblerId) {
        return null;
    }
    var stored = localStorage.getItem(getChequeBlockKey(gamblerId));
    if (!stored) {
        return null;
    }
    var blockUntil = parseInt(stored, 10);
    return Number.isNaN(blockUntil) ? null : blockUntil;
};
export var getChequeBlockRemaining = function (gamblerId) {
    var blockUntil = getChequeBlockUntil(gamblerId);
    if (!blockUntil) {
        return 0;
    }
    var remaining = blockUntil - Date.now();
    return remaining > 0 ? remaining : 0;
};
export var isChequeBlocked = function (gamblerId) { return getChequeBlockRemaining(gamblerId) > 0; };
export var clearChequeBlock = function (gamblerId) {
    if (!gamblerId) {
        return;
    }
    localStorage.removeItem(getChequeBlockKey(gamblerId));
};
export var formatRemainingTime = function (remainingMs) {
    var seconds = Math.floor(remainingMs / 1000) % 3600;
    var minutes = Math.floor(seconds / 60);
    seconds = seconds % 60;
    return "".concat(minutes, ":").concat(seconds < 10 ? '0' : '').concat(seconds);
};



// WEBPACK FOOTER //
// ./src/shared/chequeBlockStorage.js